module.exports = __webpack_public_path__ + "img/simona-key-account-instadrive-elektroauto-abo.3ebb58e9.webp";